<template>
  <b-card>
    <b-table
      show-empty
      head-variant="dark"
      striped
      hover
      bordered
      :items="items"
      :fields="fields"
    >
      <template v-slot:cell(no)="data">
        {{ data.index + 1 }}
      </template>
      <template v-slot:cell(action)="data">
        <span>
          <b-button
            variant="primary"
            size="sm"
            @click="onClickDelete(data.index)"
            >{{ data.value.view }}DELETE</b-button
          >
        </span>
      </template>
      <template slot="bottom-row" slot-scope="data">
        <td align="right" :span="data.columns" colspan="5">
          <b>Grand Total Price (RM)</b>
        </td>
        <td :span="data.columns">{{ grand.toFixed(4) }}</td>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  data() {
    return {};
  },
  props: {
    fields: {
      type: Array,
      required: true
    },
    items: {
      type: Array,
      required: true
    },
    grand: {
      type: Number
    }
  },
  methods: {
    onClickDelete(index) {
      this.$emit("delete", index);
    }
  }
};
</script>
<style lang="css" scoped></style>
